import { Controller } from "@hotwired/stimulus"
import SignupFormHelper from "../helpers/signup_form_helper"

// Mounted on the terms modal itself (shared/lasso/_personal_terms_modal.html.haml,
// _business_terms_modal.html.haml), not on the page that opens it - these partials are rendered
// under both invitations_controller.js and signup_controller.js, so the Print button can't name
// either page-level controller by identifier. `printTerms` (now
// SignupFormHelper.printTerms) always targeted `#<modal id> .terms-and-conditions`, so the
// modal's own id is enough context; no data needs to travel in from the opening page.
export default class extends Controller {
  print() {
    SignupFormHelper.printTerms(`#${this.element.id} .terms-and-conditions`);
  }
}
